import React from 'react'
import { loginStore } from '../../state/CommonState'
import VisibilityDataTable from './visibilitydatatable'

export default function ChartVisibilityHome() {


    const CATEGORIES = {
        MSME: `MSME`,
        ENTERPRISE: `Enterprise`,
    }

  return (
    <div className="" style={{ padding : "2% 1%" , backgroundColor : "#e3e5e8" , marginBottom : '0.5%' }}>
          <div className='wd_100'>
              <p
                  className="figtree-text"
                  style={{ fontSize: "28px" }}>
                  Welcome back , <span style={{ color: "#E87A1A" }}>{loginStore.userRec.firstName + ' ' + loginStore.userRec.lastName}!  </span>
              </p>
          </div>
          <div className='is-flex' style={{ backgroundColor: "white", borderRadius: "5px", padding: "1% 2%", marginBottom: "1%" }}>
              <div style={{ width: '25%' }} >
                  <p
                      className="label is-small figtree-text"
                      style={{ marginBottom: "0px", fontWeight: '400' }}>
                      Entity Category
                  </p>
                  <select name="status" id="status" style={{ padding: "1% 3%", height: '35px', width: "95%", fontWeight: '400', border: '1px solid #BABABA', borderRadius: '5px' }}
                  //   onChange={(e) => filterEntities(e.target.value )}
                  >
                      <option value="ALL">ALL</option>
                      {
                          Object.values(CATEGORIES)?.map((r, i) => {
                              return <option value={r}>{r}</option>
                          })
                      }

                  </select>

              </div>
          </div>
          <VisibilityDataTable/>
     
    </div>
  )
}


